export const isValidActionDate = (actionDate) => {
  if (!actionDate) {
    return false;
  }

  if (actionDate instanceof Date) {
    return !Number.isNaN(actionDate.getTime());
  }

  if (typeof actionDate === "string") {
    const parsedDate = new Date(actionDate);
    return actionDate.trim().length > 0 && !Number.isNaN(parsedDate.getTime());
  }

  return false;
};
